<template>
  <div class="academy_edu_learn-container" id="EducCenter">
    <div class="academy_edu_learn-wrapper">
      <header class="academy_edu_learn-hd">
        Quickly Learn Digital Design Software Products Here
      </header>
      <article class="academy_edu_learn-bd">
        <div class="edu_learn-item">
          <img
            src="@/assets/images/academy/academy_edu_learn_1.png"
            class="edu_learn-img"
          />
          <div class="edu_learn_content">
            <div
              class="edu_learn_content_wrapper"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              <h2 class="content-label">
                Singapore Authorized Education and Learning Center
              </h2>
              <p class="content-text">
                The center integrates classroom teaching, online learning,
                specialized discussions, and hands-on software practice. It
                employs heuristic, interactive, and varied practice methods, as
                well as the establishment of an online learning platform. A
                large number of practical design engineering cases are used in
                the teaching process.
              </p>
            </div>
          </div>
        </div>
        <div class="edu_learn-item trans">
          <img
            src="@/assets/images/academy/academy_edu_learn_2.png"
            class="edu_learn-img"
          />
          <div class="edu_learn_content">
            <div
              class="edu_learn_content_wrapper"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              <h2 class="content-label">
                Indonesia Authorized Education and Learning Center
              </h2>
              <p class="content-text">
                The center combines classroom lectures, online learning,
                thematic discussions, and software practical exercises. It
                utilizes heuristic, interactive, and variation exercises, along
                with the establishment of an online learning platform. The
                teaching is supported by numerous practical design engineering
                cases.
              </p>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.academy_edu_learn-container {
  padding: 80px 0;
  background: #fff;
  .academy_edu_learn-wrapper {
    width: 1049px;
    margin: 0 auto;
  }

  .academy_edu_learn-hd {
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 24px;
    color: #1d1d1f;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .academy_edu_learn-bd {
    font-weight: 400;
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }

  .edu_learn-item {
    display: flex;
    align-items: center;
    height: 298px;
    margin-bottom: 40px;
    .edu_learn-img {
      width: 518px;
      order: 1;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.05);
      }
    }
    .edu_learn_content {
      flex: 1;
      order: 2;
    }
    .edu_learn_content_wrapper {
      padding: 45px 50px 45px 90px;
    }
    .content-label {
      margin-bottom: 24px;
      font-weight: bold;
      font-size: 24px;
      color: #1d1d1f;
      line-height: 32px;
      text-align: left;
      font-style: normal;
    }
    .content-text {
      font-weight: 400;
      font-size: 12px;
      color: #1d1d1f;
      line-height: 24px;
      text-align: justify;
      font-style: normal;
    }

    &.trans {
      margin-bottom: 0;
      .edu_learn_content {
        order: 1;
      }
      .edu_learn-img {
        order: 2;
      }
      .edu_learn_content_wrapper {
        padding: 45px 90px 45px 0px;
      }
    }
  }
}
</style>
